import { useLocation } from 'react-router-dom';

export function urlWithParams (params = {}) {
	let currentUrlParams = new URLSearchParams(false === params ? '' : window.location.search);

	Object.keys(params).map((key) => {
		const value = String(params[key]);
		if (value.length > 0) {
			currentUrlParams.set(key, params[key]);
		} else {
			currentUrlParams.delete(key);
		}
		return true;
	});

	return `${window.location.pathname}?${currentUrlParams.toString()}`;
}

export function useQuery () {
	return new URLSearchParams(useLocation().search);
}